export default function Section2() {
  return (
    <div className="Section2 p-0 xs:-mt-[50px] md:pb-[35px] md:-mt-[100px]">
      <div className="section2-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px]">
        <h1 className="w-[50%] md:w-auto text-[24px] leading-[1.1] md:text-[34px] md:leading-[1.3] font-bold">
          TikTok Marketing Services in <br /> Dubai & Across the UAE
        </h1>

        <h2 className="text-[#da2128] w-[50%] md:w-auto !text-[24px] leading-[1.1] md:!text-[20px] md:leading-[1.2] font-bold mt-3">
          Dominate TikTok with High-Impact Campaigns <br /> That Drive Engagement & Sales
        </h2>

        <p className="text-[12px] md:text-[14px] w-[72%] md:w-[45%] text-[#535353] md:text-[#373737] mb-5 font-open mt-5">
          At Mean3, we help brands in Dubai, Abu Dhabi, Sharjah and across the UAE use TikTok to reach new audiences, build brand awareness, and turn followers into customers. As a leading TikTok marketing agency in the UAE, we combine creative short-form video content, data-driven ad campaigns, influencer collaborations and performance analytics to deliver measurable results.        </p>
      </div>
    </div>
  );
}
